<template>
	<a :href="item.link" class="c-profile-block c-profile-block--link">
		<div class="c-profile-block__image">
			<div class="o-image" style="padding-top: 100%;">
				<img class="o-image__full" :src="item.coverImageUrl" :class="{'isLoaded':item.coverImageSrcset}"
				v-bind:srcset="item.coverImageSrcset" v-if="loaded"/>
				<div class="o-image__preview"  v-bind:style="{backgroundImage : 'url('+ item.preview.url +')'}" v-if="item.preview"></div>
			</div>
		</div>
		<h3 class="h-delta h-text--reg h-margin-bottom--none">{{item.firstName}}<br/>{{item.lastName}}</h3>
		<span class="c-profile-block__posttitle h-text--micro" v-if="item.role">{{item.role}}</span>
	</a>
</template>

<script>
	import axios from 'axios';

  export default {
		name: 'profile-block',
		data: function () {
			return {
				loaded : false
			}
		},
		props: {
			item: {
				type: Object
			},
		},
		methods: {
			getImageUrl() {
				if (this.item.imageId) {
					var url = '/api/srcset.json?id='+ this.item.imageId +'&srcset=118,236&aspectRatio=1';
					var self = this;

					axios.get(url, { crossdomain: true })
					.then((response) => {
						self.item.coverImageSrcset = response.data.data[0].transform.srcset;
						self.loaded = true
					})
				}
				else {
					var self = this;

					self.item.coverImageUrl = 'https://s3-eu-west-1.amazonaws.com/newadventures/Placeholders/avatar.png';
					self.item.coverImageSrcset = self.item.coverImageUrl;
					self.loaded = true

				}
			},
		},
		mounted() {
			this.getImageUrl()
		},
  }
</script>



// WEBPACK FOOTER //
// profile-block.vue?6d8fc41c